import { createTimingChannel } from '@atlassian/commerce-telemetry/events';
var _createTimingChannel = createTimingChannel(),
  FormStartTimeRecorder = _createTimingChannel.StartTimeRecorder,
  FormStartTimeProvider = _createTimingChannel.StartTimeProvider,
  useFormStartTimeRef = _createTimingChannel.useStartTimeRef;
export { FormStartTimeRecorder, FormStartTimeProvider, useFormStartTimeRef };